import React, { useState, useEffect } from "react";
import Slider from "@mui/material/Slider";

import { styled } from "@mui/system";

const StyledSlider = styled(Slider)({
  color: "var(--primary-color-600)",
  "& .MuiSlider-thumb": {
    width: 3,
    borderRadius: 0,
    height: 18,
    marginLeft: 0,
    color: "#aaa",
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "none",
    },
  },
  "& .MuiSlider-track": {
    height: 8,
  },
  "& .MuiSlider-rail": {
    height: 8,
  },
  "& .MuiSlider-valueLabel": {
    background: "transparent",
    color: "#000",
    transform: "translateY(-70%) scale(1)!important",
  },
});

function getRangeV2(matchingFilterString, filterType) {
  let bottomRange = filterType.min;
  let topRange = filterType.max;
  matchingFilterString.forEach((item, i) => {
    if (item[0] === ">") {
      bottomRange = Number(item.substring(1));
    } else if (item[0] === "<") {
      topRange = Number(item.substring(1));
    }
  });
  return [bottomRange, topRange];
}

function SliderFilter(props) {
  let [sliderValues, setSliderValues] = useState(
    getRangeV2(props.matchingFilterString, props.filterType)
  );

  useEffect(() => {
    setSliderValues(getRangeV2(props.matchingFilterString, props.filterType));
  }, [props.matchingFilterString, props.filterType]);

  const handleChange = (event, newValue) => {
    setSliderValues(newValue);
  };

  const createFiltersV2 = () => {
    let returnFilters = [];
    if (sliderValues[0] !== props.filterType.min) {
      returnFilters.push(">" + sliderValues[0]);
    }

    if (sliderValues[1] !== props.filterType.max) {
      returnFilters.push("<" + sliderValues[1]);
    }

    props.updateFilters(returnFilters, props.filterType.data);
  };

  return (
    <div style={{ padding: "20px 0px 10px" }}>
      <StyledSlider
        value={sliderValues}
        min={props.filterType.min}
        max={props.filterType.max}
        step={props.filterType.step}
        valueLabelFormat={(x) => x}
        onChange={handleChange}
        onChangeCommitted={createFiltersV2}
        valueLabelDisplay="on"
        aria-labelledby="range-slider"
      />
    </div>
  );
}

export default SliderFilter;
